import React from "react";
import { Card, Button, Row, Col } from "antd";
import "./OtherCoursesCard.less";

const OtherCoursesCard = (props) => {
  return (
    <Card className="pending-card">
      <div className="cover-image">
        <img
          src={props.lectureImage}
          alt="Lecturer"
          className="lecturer-image"
        />
      </div>
      <Row className="card-content">
        <Col span={16} className="details">
          <div className="lecture-name">
            <p className="label">Subject name</p>
            <p className="value">{props.subjectname}</p>
          </div>
          <div className="date-time">
            <p className="label">Status</p>
            <p className="value">{props.status}</p>
          </div>
        </Col>
        <Col span={8} className="view-button-container">
          <Button type="primary" className="view-button">
            View
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default OtherCoursesCard;
